<script lang="ts">
  import { applyAction } from '$app/forms';
  import Button from '$components/elements/Button.svelte';
  import Form from '$components/elements/Form.svelte';
  import Heading from '$components/elements/Heading.svelte';
  import Input from '$components/elements/Input.svelte';
  import Modal from '$components/elements/Modal.svelte';
  import Flex from '$components/layout/Flex.svelte';
  import Text from '$components/utils/Text.svelte';
  import { globalError } from '$lib/stores';
  import type { QuoteParsed } from '$types/quote';
  import type { SubmitFunction } from '@sveltejs/kit';

  export let quote: QuoteParsed;

  let showModal = false;
  let showSuccessModal = false;
  let loading = false;

  function onClose() {
    showModal = false;
  }

  function onCloseSuccess() {
    showSuccessModal = false;
  }

  const submitSignUp: SubmitFunction = () => {
    loading = true;
    return async ({ result, update }) => {
      await applyAction(result);
      if ('data' in result && typeof result.data === 'object' && 'message' in result.data) {
        globalError.set(result.data.message as string);
      } else {
        showSuccessModal = true;
      }
      onClose();
      await update({ reset: false });
      loading = false;
    };
  };
</script>

<Modal bind:showModal {onClose} width="fit-content">
  <Flex margin="auto 64px">
    <Form submit={submitSignUp} action="/backend/quote/register">
      <Flex width="100%" gap="50px" direction="column" alignItems="start" margin="83px auto">
        <Heading textAlign="left">
          <Text key="component.daily-words.heading" />
        </Heading>
        <Input type="email" name="email" label="Email" required />
        <Flex width="100%" gap="20px" direction="column" alignItems="start">
          <Button width="100%" submit {loading}>
            <Text key="component.daily-words.button" />
          </Button>
          <Button
            on:click={onClose}
            textColor="#1d1d1b"
            color="#fff"
            border="2px solid #1d1d1b"
            slimness="super-slim"
            width="100%"
          >
            <Text key="component.daily-words.close" />
          </Button>
        </Flex>
      </Flex>
    </Form>
  </Flex>
</Modal>

<Modal bind:showModal={showSuccessModal} onClose={onCloseSuccess}>
  <Flex margin="auto 64px">
    <Flex width="100%" gap="50px" direction="column" alignItems="start" margin="83px auto">
      <p class="daily-word__text">
        <Text key="component.daily-words.success" />
      </p>
      <Flex width="100%" gap="20px" direction="column" alignItems="start">
        <Button on:click={onCloseSuccess} width="100%">
          <Text key="component.daily-words.close" />
        </Button>
      </Flex>
    </Flex>
  </Flex>
</Modal>

<div class="daily-word">
  <span class="daily-word__quote"
    >{quote.text} <a href="/online{quote.link}">{quote.reference}</a></span
  >
  <span class="daily-word__button">
    <Button color="#c99e77" on:click={() => (showModal = true)}>
      <Text key="component.daily-words.button" />
    </Button>
  </span>
</div>

<style lang="scss">
  .daily-word {
    background-color: $color-white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 70px;
    margin: 83px auto;
    width: 80%;
    max-width: 1280px;
    padding: 25px 30px 25px 40px;
    border-radius: 13px;
    box-shadow: 0px 6px 24px rgba(29, 29, 27, 0.05);
  }
  .daily-word__quote {
    font-size: 14px;
    line-height: 22px;
    font-style: italic;
    a {
      color: $color-caramel;
      transition: 0.3s ease all;
      &:hover {
        color: inherit;
      }
    }
  }
  .daily-word__text {
    font-size: 22px;
    line-height: 22px;
  }
  @media screen and (max-width: 1024px) {
    .daily-word {
      gap: 28px;
    }
  }
  @media screen and (max-width: 800px) {
    .daily-word {
      flex-direction: column;
    }
    .daily-word__button {
      align-self: flex-end;
    }
  }
</style>
